import styled, { css } from 'styled-components';

export const TableRow = styled.div`
  display: grid;
  ${({ heading }) => {
    if (heading) {
      return css`
        grid-column-start: 1;
        grid-column-end: 3;
        margin-bottom: 4px;
        font-size: 16px;
      `;
    }
  }};

  @media print {
    font-size: 14px;
  }
`;
